import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { App, Input, Table } from 'antd';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import useComponentInstancesApi from 'pages/liftlogic/v2/Components/useComponentInstancesApi';

function EquiposListContent() {
  const { tenantId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const api = useComponentInstancesApi();
  const { message } = App.useApp();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [q, setQ] = useState('');

  const refresh = useCallback(async () => {
    setLoading(true);
    try {
      const data = await api.listEquipos(Number(tenantId));
      setRows(data.rows || []);
    } catch (e) {
      message.error('No se pudieron cargar los equipos');
    } finally {
      setLoading(false);
    }
  }, [api, tenantId, message]);
  useEffect(() => {
    refresh();
  }, [refresh]);

  const filtered = useMemo(() => {
    const t = q.trim().toLowerCase();
    if (!t) return rows;
    return rows.filter((r) =>
      [r.nombre, r.marca, r.modelo, r.numero_serie, r.cliente_nombre, r.edificio_nombre]
        .filter(Boolean)
        .some((v) => String(v).toLowerCase().includes(t))
    );
  }, [rows, q]);

  const columns = [
    { title: 'Equipo', dataIndex: 'nombre' },
    {
      title: 'Marca/Modelo',
      render: (_, r) => [r.marca, r.modelo].filter(Boolean).join(' ') || '—',
    },
    { title: 'N° serie', dataIndex: 'numero_serie' },
    { title: 'Cliente', dataIndex: 'cliente_nombre' },
    { title: 'Edificio', dataIndex: 'edificio_nombre' },
  ];

  return (
    <>
      <Input.Search
        placeholder="Buscar por nombre, serie, cliente…"
        allowClear
        style={{ maxWidth: 360, marginBottom: 12 }}
        onChange={(e) => setQ(e.target.value)}
      />
      <Table
        rowKey="id"
        loading={loading}
        columns={columns}
        dataSource={filtered}
        onRow={(r) => ({
          style: { cursor: 'pointer' },
          onClick: () =>
            navigate(`/admin/tenants/${tenantId}/ascensores/${r.id}/components`, {
              state: { ...location.state, equipo: r },
            }),
        })}
      />
    </>
  );
}

export default EquiposListContent;
